import React from 'react';
import Modal from 'react-modal';
import './ErrorPage.css';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth:"700px",
    width: "100%",
    padding: "50px",
    fontSize: "24px"
  },  
};

const TimeOutModal = ({isOpen, onRequestClose, logOut}) => {

  const handleLogOut = () => {
    logOut();
    onRequestClose(); // Close the modal after logout
  };
  
  return (
    <div> 
      <Modal
        isOpen={isOpen}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className='errorPage'>
        <h1>Session Timeout</h1>
        <div>You're being timed out due to inactivity. Please choose the below <span style={{backgroundColor:'lightblue'}}>Log off</span> Button or <span style={{backgroundColor:'lightblue'}}>Stay Logged In</span> Button. Otherwise, you will be Log off automatically in few Seconds!</div>
        <br />
        <div className='errorPageButton'>
          <button onClick={handleLogOut} className='btn btn-primary'>Log off</button> &nbsp; &nbsp;
          <button onClick={onRequestClose} className='btn btn-primary'>Stay Logged In</button>
        </div>
        </div>
      </Modal>
    </div>  
  );
}

export default TimeOutModal;
